import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {CardModule} from "primeng/card";

@Component({
  selector: "app-statistic-card",
  standalone: true,
  imports: [CardModule],
  templateUrl: "./statistic-card.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StatisticCardComponent {
  @Input({required: true}) icon!: string;
  @Input({required: true}) iconColor!: string;
  @Input({required: true}) value!: string;
  @Input({required: true}) label!: string;
  @Input() valueSize: 'normal' | 'large' = 'normal';
}
